__turbopack_context__.v({
  "icon": "Toast-module__aQwjIW__icon",
  "message": "Toast-module__aQwjIW__message",
  "toast": "Toast-module__aQwjIW__toast",
  "toast--bottom-center": "Toast-module__aQwjIW__toast--bottom-center",
  "toast--bottom-left": "Toast-module__aQwjIW__toast--bottom-left",
  "toast--bottom-right": "Toast-module__aQwjIW__toast--bottom-right",
  "toast--error": "Toast-module__aQwjIW__toast--error",
  "toast--hidden": "Toast-module__aQwjIW__toast--hidden",
  "toast--info": "Toast-module__aQwjIW__toast--info",
  "toast--inline": "Toast-module__aQwjIW__toast--inline",
  "toast--lg": "Toast-module__aQwjIW__toast--lg",
  "toast--md": "Toast-module__aQwjIW__toast--md",
  "toast--sm": "Toast-module__aQwjIW__toast--sm",
  "toast--success": "Toast-module__aQwjIW__toast--success",
  "toast--top-center": "Toast-module__aQwjIW__toast--top-center",
  "toast--top-left": "Toast-module__aQwjIW__toast--top-left",
  "toast--top-right": "Toast-module__aQwjIW__toast--top-right",
  "toast--warning": "Toast-module__aQwjIW__toast--warning",
});
